import React from 'react';
import { observer } from 'mobx-react-lite';
import { SummarySection } from './SummarySection';
import { useMyHealthStore } from 'store/mobx/mobx';
import { BaseSectionItem } from './BaseSectionItem';
import moment from 'moment';
import { IAccident } from 'store/mobx/myHealthStore/myHealthStore.type';

function getTooltipText(item: IAccident) {
  if (item.AccidentNumber) {
      return [
        `Accident Number: ${item.AccidentNumber}`,
        `Status: ${item.Status}`,
        `Date: ${moment(item.AccidentDateTime).format('DD/MM/YYYY')}`, 
        `Insurer: ${item.Insurer}`,
        `Description: ${item.Description}`,
        `Diagnosis: ${item.Description}`,
        `Practitioner: ${item.ProviderName}`
      ];
  }
  return [];
}

export const AccidentSection: React.FC = observer(() => {
  const { Accidents } = useMyHealthStore().summaryTab;

  return (
    <div>
    {Accidents?.length > 0 &&
      <SummarySection title="Accidents" observableData={Accidents}>
        {Accidents.map(item => (
          <BaseSectionItem
            key={item.AccidentNumber}
            label={item.Description}
            date={item.AccidentDateTime}
            tooltipText={getTooltipText(item)}
          />
        ))
      }
      </SummarySection>
    }
    </div>
  );
});
